import React, { useState } from 'react';
import { StudentType } from '../helpers/definitions';
import PrimaryButton from '../components/Students/PrimaryButton';
import useStudents from '../hooks/useStudents';

const StudentImporter = () => {
  const [students, setStudents] = useState<StudentType[]>([]);

  const { createStudents } = useStudents();

  const fileUploadHandler = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const rows = await parseCSV(file);
      setStudents(
        rows.map((row) => ({
          barcode: row.barcode,
          firstName: row.first_name,
          lastName: row.last_name,
          primaryParentPhone: row.primary_parent_phone,
          secondaryParentPhone: row.secondary_parent_phone,
          sessionTime: parseInt(row.session_time),
          sendText: row.send_text === 'true',
        })) as StudentType[],
      );
    }
  };

  const validateStudents = (students: StudentType[]): boolean => {
    const errors = [];
    students.forEach((student) => {
      const error = [student.firstName + ' ' + student.lastName];
      if (student.firstName.length > 30) {
        error.push('firstName');
      }
      if (student.lastName.length > 30) {
        error.push('lastName');
      }
      if (student.primaryParentPhone.length < 10 || !student.primaryParentPhone.match(/^[0-9]+$/)) {
        error.push('primaryParentPhone');
      }
      if (
        student.secondaryParentPhone &&
        (student.secondaryParentPhone.length < 10 ||
          !student.secondaryParentPhone.match(/^[0-9]+$/))
      ) {
        error.push('secondaryParentPhone');
      }
      if (!student.barcode.match(/^[0-9]+$/)) {
        error.push('barcode');
      }

      if (error.length > 1) {
        errors.push(error.join(', '));
      }
    });

    if (errors.length > 0) {
      return false;
    } else {
      return true;
    }
  };

  const parseCSV = async (file: File) => {
    const text = await file.text();
    const lines = text.trim().split('\n');

    const headers = [
      'barcode',
      'first_name',
      'last_name',
      'primary_parent_phone',
      'secondary_parent_phone',
      'session_time',
      'send_text',
    ];

    const rows = lines.slice(1).map((line) => {
      const values = line.split(',').map((v) => v.trim());
      return Object.fromEntries(headers.map((h, i) => [h, values[i]]));
    });

    return rows;
  };

  const studentsPreview = () => (
    <table className="table-auto w-full">
      <thead>
        <tr>
          <th className="px-4 py-2">Barcode</th>
          <th className="px-4 py-2">First Name</th>
          <th className="px-4 py-2">Last Name</th>
          <th className="px-4 py-2">Primary Parent Phone</th>
          <th className="px-4 py-2">Secondary Parent Phone</th>
          <th className="px-4 py-2">Session Time</th>
          <th className="px-4 py-2">Send Text?</th>
        </tr>
      </thead>
      <tbody>
        {students.map((student) => (
          <tr className="odd:bg-gray-300 even:bg-white" key={student.barcode}>
            <td className="border px-4 py-2">{student.barcode}</td>
            <td className="border px-4 py-2">{student.firstName}</td>
            <td className="border px-4 py-2">{student.lastName}</td>
            <td className="border px-4 py-2">{student.primaryParentPhone}</td>
            <td className="border px-4 py-2">{student.secondaryParentPhone}</td>
            <td className="border px-4 py-2">{student.sessionTime}</td>
            <td className="border px-4 py-2">{student.sendText ? 'Yes' : 'No'}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
  return (
    <>
      <div className="flex justify-evenly">
        <a
          className="bg-indigo-600 hover:bg-indigo-500 text-white font-bold py-2 px-4 rounded"
          href="/upload_template.csv"
          download="upload_template.csv"
        >
          Download Import Template
        </a>

        <label className="bg-indigo-600 hover:bg-indigo-500 text-white font-bold py-2 px-4 rounded">
          Upload Students
          <input type="file" onChange={fileUploadHandler} className="hidden" />
        </label>
      </div>

      <div>
        <h1 className="font-bold text-lg">Preview</h1>
        {students.length === 0 ? 'Click upload to see preview' : studentsPreview()}
      </div>
      <PrimaryButton
        onClick={() => {
          const res = validateStudents(students);
          if (!res) {
            alert('Invalid students. Please check the preview and try again');
            return;
          }
          createStudents(students).then((res) => {
            if (res) {
              alert('Students successfully imported');
              setStudents([]);
            } else {
              alert('Error importing students. Please try again later');
            }
          });
        }}
        label="Import Students"
        disabled={students.length === 0}
      />
    </>
  );
};

export default StudentImporter;
